export type SortKey = "latest" | "oldest" | "hot";

interface CategoryFiltersProps {
  sort: SortKey;
  onSortChange: (sort: SortKey) => void;
  tags: string[];
  activeTag: string;
  onTagChange: (tag: string) => void;
  resultCount: number;
}

const sortOptions: { key: SortKey; label: string; icon: string }[] = [
  { key: "latest", label: "最新发布", icon: "ri-time-line" },
  { key: "oldest", label: "最早发布", icon: "ri-history-line" },
  { key: "hot", label: "最多播放", icon: "ri-fire-line" },
];

export default function CategoryFilters({
  sort,
  onSortChange,
  tags,
  activeTag,
  onTagChange,
  resultCount,
}: CategoryFiltersProps) {
  return (
    <div className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:flex-row md:items-center md:justify-between">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-6">
        <div className="flex items-center gap-1 rounded-full bg-background-100 p-1">
          {sortOptions.map((opt) => (
            <button
              key={opt.key}
              type="button"
              onClick={() => onSortChange(opt.key)}
              className={`flex items-center gap-1 rounded-full px-3 py-1.5 text-sm font-medium transition-colors whitespace-nowrap ${
                sort === opt.key
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className={`${opt.icon} text-sm`} />
              </span>
              {opt.label}
            </button>
          ))}
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={() => onTagChange("")}
            className={`rounded-full border px-3 py-1 text-xs font-medium transition-colors ${
              activeTag === ""
                ? "border-secondary-500 bg-secondary-500 text-background-50"
                : "border-background-200 bg-background-50 text-foreground-600 hover:border-secondary-300"
            }`}
          >
            全部
          </button>
          {tags.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => onTagChange(tag)}
              className={`rounded-full border px-3 py-1 text-xs font-medium transition-colors ${
                activeTag === tag
                  ? "border-secondary-500 bg-secondary-500 text-background-50"
                  : "border-background-200 bg-background-50 text-foreground-600 hover:border-secondary-300"
              }`}
            >
              {tag}
            </button>
          ))}
        </div>
      </div>

      <p className="shrink-0 text-xs text-foreground-500">
        共 <span className="font-semibold text-primary-600">{resultCount}</span> 个视频
      </p>
    </div>
  );
}